import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LayoutService } from '../layout.service';
import { SubscriptionBannerService } from 'src/app/services/subscription-banner.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu-layout',
  templateUrl: './menu-layout.component.html',
  styleUrls: ['./menu-layout.component.scss']
})
export class MenuLayoutComponent implements OnInit, AfterViewInit{
  @ViewChild('navbarlayout', { static: true, read: ElementRef }) navbar!: ElementRef;
  subscriptionBanners: any[] = [];
  constructor(public SubscriptionBannerService: SubscriptionBannerService, private router:Router){}

  ngOnInit(): void {
    this.SubscriptionBannerService.fetchSubscriptionBillingAlertsBanners();
    this.SubscriptionBannerService.subscriptionBannersObservable$.subscribe((data: any) => {
      this.subscriptionBanners = data.banners || [];
    }
    );
  }

  ngAfterViewInit() {
  }

  public closeBanner(banner: any): void {
    const idx = this.subscriptionBanners.indexOf(banner);
    if (idx > -1) {
      this.subscriptionBanners[idx].hide = true;
    }
    const newBannerData = {
      banners: this.subscriptionBanners,
      lastFetchedAt: new Date().toISOString()
    } 
    localStorage.setItem('SubscriptionBanners', JSON.stringify(newBannerData));
  }

  public gotoSubscriptionDetails(){
    this.router.navigate(['/profile/SubscriptionDetails'])
  }

}
